<template>
  <div>
    <van-nav-bar
            title="批量件明细页面"
            left-text="返回"
            left-arrow
            @click-left="onClickLeft"
    />
    <!-- 不动产查询结果页 -->
    <div class="mainbox">
      <Head v-if="logo" :logo="logo"></Head>
            <div v-for="(val,i) in dataList" :key="i"  class="jgform">
              <div class="title">
                  <div>
                    <image src="../../static/imgs/no.png" mode="widthFix"></image>
                    <span>业务流水号: {{val.lsh}}</span>
                  </div>
                  <span>{{val.isConfirm==0?'未缴费':val.isConfirm==1?'已缴费':val.isConfirm==9?'支付中':''}}</span>
                </div>
                <div class="contentbox">
                  <div v-for="(item,index) in dataForm" :key='index'>
                    <span>{{item.label}}</span>
                    <span>:</span>
                    <span>{{val[item.value]}}</span>
                  </div>
              </div>
              <div v-if='val.isConfirm == 1' class="cu-form-group">
                <!-- 批量件才查看明细 -->
                <div class="ticket" @click="getTicket(val)">查看电子票</div>
              </div>
            </div>



            <div class="replay" @click="handlePage">
              <div v-if="hasmore">
                <div v-if="pageLoading">
                  <van-loading size="24px">加载中...</van-loading>
                </div>
                <div v-else>
                  <van-icon name="replay" />点击加载更多数据
                </div>
              </div>
              <div v-else>暂无更多数据</div>
            </div>

        <Foot v-if="footList && footList.bottomMessage && footList.bottomMessage.length>0" :list="footList"></Foot>
        
    </div>
  </div>

</template>

<script>
import Foot from "@/components/foot";
import Head from "@/components/head";
import List from "@/components/list";
import ListBdc from "@/components/listBdc";
import {Toast,Dialog} from "vant";
export default {
  components: {
    Foot,
    Head,
    List,
    ListBdc,
  },
  data() {
    return {
      showD:false,
      queryInfo:{},
      logo: "",
      footList: [], //温馨提示列表
      dataList: [],
      dataForm:[
      {label:'执收机关代码',value:'glbm'},
        {label:'执收机关名称',value:'glbmName'},
        {label:'缴款人',value:'xm'},
        {label:'缴款金额',value:'payTotal'},
        {label:'业务类型',value:'busName'},
      ],
      total: 0,
      hasmore: true,
      pageLoading: false,

    };
  },
  created() {
    this.initData()
    this.getFootData();
    this.getHeadImg();
    this.getData()
  },
  destroyed() {
    Toast.clear();
  },
  methods: {
    closeO(){
      this.showD=false;
    },
    initData() {
      this.queryInfo = this.$route.query?this.$route.query:{};
      this.queryInfo.page = 1;
      this.queryInfo.limit = 5;
    },
    // 获取头像
    getHeadImg() {
      this.request({
        url:'/webPortal/websitConfig',
        method:'get',
        params:{vde:this.queryInfo.vde}
      }).then((res)=>{
        if (res.data.code == 1000 && res.data.result) {
          if(res.data.result.logoUrlLogin) {
            this.logo = res.data.result.logoUrlLogin;
          }else {
            this.logo = require("@/assets/img/logo.png");
          }
          sessionStorage.setItem("title", res.data.result.websitTitle);
          document.title=res.data.result.websitTitle
        }else if (res.data.code != 1000){
           this.$router.push({ path: "/404" });
        }
      })
    },
    // 获取底部数据
    getFootData() {
      let data = {
        vde: this.queryInfo.vde,
        type: 4
      };
      this.request({
        url:'/systemManage/mobileGetMessage',
        method:'get',
        params:data
      }).then((res)=>{
        if (res.data.code == 1000) {
          this.footList = res.data.result;
        } else {
        }
      })
    },
    // 分页
    handlePage() {
      this.pageLoading = true;
      if (this.dataList.length < this.total) {
        this.queryInfo.page++;
        this.getData();
      }
    },
    getData() {
        this.request({
          baseURL: process.env.VUE_APP_PAY_URL,
          url:'/tc_offline/listBatchDetails',
          method:'post',
          data:this.queryInfo
        }).then((res)=>{
            this.pageLoading = false;
            this.refreshing = false;
          if (res.data.code == 1000) {
              if (res.data.result != null) {
                if (this.queryInfo.page == 1) {
                   this.dataList = res.data.result.list;
                }else {

                  this.dataList = this.dataList.concat(res.data.result.list);
                }
                this.total = res.data.result.total;
                if (this.dataList.length == this.total) {
                  this.hasmore  = false;
                }else {
                  this.hasmore = false;
                }
              }else{
                if(!res.data.errorMessage){
                  this.$CDialog({
                    confirmBtnText: "确认",
                    title: "提示",
                    status: "2",
                    textSize: 16,
                    message: res.data.message
                  })
                }
            }
          }		
        })
    },
    // 页面点击返回
    onClickLeft(){
      this.$router.go(-1)
    },
    getTicket(item) {
        this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url:'/tc_offline/checkBill',
        method:'post',
        data:{
          lsh:item.batchLsh,
          glbm:item.glbm,
          paymentType:2,
          detailLsh:item.lsh,
        }
      }).then((res)=>{
        if (res.data.code == 1000) {
          this.$router.push({path:'/eTicket?url='+encodeURIComponent(res.data.message)})
        }else {
            Toast(res.data.message);
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.mainbox {
  padding: 0 2vw;
  box-sizing: border-box;
   .replay {
    text-align: center;
    color: #7e7e7e;
  }
  	.jgform {
		border-radius:2px;
		box-sizing: border-box;
		background-color: #fff;
		box-shadow:4px 4px 5px 0px rgba(51,51,51,0.05);
    border-radius:5px;
		margin-bottom: 15px;
		.title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height:32px;
			box-sizing: border-box;
			padding: 0 14px;
			border-radius:2px 2px 0px 0px;
			background:#1989fa;
			>div {
				image {
					width: 14px;
					margin-right: 13px;
					position: relative;
					top: 2px;
				}
			}
			span {
				font-size:15px;
				font-family:PingFang SC;
				font-weight:400;
				color:rgba(255,255,255,1);
				line-height:31px;
			}
		}
		>.contentbox {
			padding: 5px 14px 0 14px;
			font-size: 14px;
			>div {
				height: 25px;
				line-height: 25px;
				color:rgba(102,102,102,1);
				display: flex;
				> span:nth-of-type(1) {
					display: inline-block;
					width: 90px;
					text-align: justify;
					font-size:14px;
					font-family:PingFang SC;
					color:rgba(102,102,102,1);
					vertical-align: top;
					&::after {
						display: inline-block;
						width: 100%;
						content: '';
						height: 0;
					}
				}
				>span:nth-of-type(2) {
					line-height: 25px;
					margin-left: 0;
					position: relative;
				}
				>span:nth-of-type(3) {
					width: 200px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					color:rgba(51,51,51,1);
					margin-left: 18px;
					display: inline-block;
				}
			}
			.remark {
				position: relative;
				z-index: 99;
			}
			.money {
				>span:nth-of-type(3) {
					color: #FF774D;
				}
			}
		}
		.cu-form-group {
			margin-top: 5px;
			border-top: 1px dashed #C8C8C8;
			padding: 10px;
      overflow: hidden;
      width: 90vw;
      >div {
				font-size:13px;
				font-family:PingFang SC;
				color:rgba(8,148,235,1);
      }
			>.detail {
        float: left;
			}
      >.ticket {
        float: right;
      }
		}
	}
}
.nodata {
  text-align: center;
  font-size: 15px;
  margin: 30px 0;
  color: #888;
}
.cont {
  margin-top: 10px;
  position: relative;
  .replay {
    text-align: center;
    color: #7e7e7e;
  }
  .touch {
    height: 30vh;
    width: 100vw;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3;
  }
}
.content {
  text-align: center;
  padding: 15px 0;
  line-height: 24px;
}
.btn {
  margin-top: 20px;
}
</style>
